// extracted by mini-css-extract-plugin
export default {"container":"PopUp_container__Q9nfA","content":"PopUp_content__KCbgB","title":"PopUp_title__L6YRn","close":"PopUp_close__T58Il","prizeList":"PopUp_prizeList__BxVBv"};